import React from "react";

import MyResourcesCard from "./Resource/MyResourcesCard";
import ThisTheme from "../../../themes/PORTTheme";

function PORTWidget() {
    return (
        <React.Fragment>
            <MyResourcesCard theme={ThisTheme} />
        </React.Fragment>
    );
}

export default PORTWidget;
